import React, { ChangeEvent, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { filterUser } from "modules/user_management/commercial_user/user/state/action";
import { FilterUserInput } from "modules/user_management/commercial_user/user/state/actionType";
import HandleCreateMembershipPlan from "./HandleCreateMembershipPlan";
import { showSnackbar } from "utils/snack_bar/store/action";
import { AppDispatch } from "index";


type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;
const GetUser: React.FC<Props> = ({
  filterUserState,
  onFilterCommercialUsers,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [searchInput, setSearchInput] = useState("");
  const [searchTerm, setSearchTerm] = useState(""); 
  const userId = filterUserState?.filteredUser?.user_id

  const detectFieldType = (input: string): "mobile_no" | "email" => {
    const trimmed = input.trim();
    const mobilePattern = /^(17|77)\d{6}$/;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (mobilePattern.test(trimmed)) {
      return "mobile_no";
    } else if (emailPattern.test(trimmed)) {
      return "email";
    } else {
      return "email"; // default to email if uncertain
    }
  };
  const handleSearch = async () => {
    if (!searchInput.trim()) {
      dispatch(showSnackbar("Please enter a mobile number or email before searching."));
      return;
    }
    const detectedField = detectFieldType(searchInput);

    const input: FilterUserInput = {
      field: detectedField,
      value: searchInput.trim(),
    };
    await onFilterCommercialUsers(input);
    setSearchTerm(searchInput);
  };

  return (
    <div className="w-full mt-8 p-8">
      <h2 className="text-2xl font-bold mb-1">Search user</h2>
      <div className="w-3/5 flex gap-2">
        <input
          type="text"
          placeholder="Search by email, mobile, or identifier"
          value={searchInput}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setSearchInput(e.target.value)
          }
          className="flex-1 border p-2 rounded border-primary-500"
        />
        <button
          onClick={handleSearch}
          className="bg-primary-500 text-white hover:bg-primary-800 hover:shadow-md px-4 py-2 rounded"
        >
          Search
        </button>
      </div>
      <div className="border-b-2 border-primary-500 py-3" />
      <div className="mt-4 p-2 max-h-[64vh] overflow-auto hide-scrollbar">
        {searchTerm.trim() === "" ? (
          <p className="text-gray-500">
            Enter a search term and click Search...
          </p>
        ) : userId ? (
          <ul>
              <div>
                <HandleCreateMembershipPlan user_id={userId}/>
              </div>
          </ul>
        ) : (
          <p className="text-red-500">No users found for "{searchTerm}"</p>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  filterUserState: state.commercialUser.filterUserState,
});

const mapDispatchToProps = (dispatch: any) => ({
  onFilterCommercialUsers: (input:FilterUserInput) => dispatch(filterUser(input)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GetUser);
